<template>
    <ModalBase
        :name="'editar-sesion-' + sesion.id"
        :title="'Editar sesión con fecha: ' + fechaFormateada"
        @close="close(false)"
    >
        <ValidationObserver ref="observer" tag="form" @submit.prevent="submit">
            <FormSesion
                :form="form"
                :loading="loading"
                :min-fecha-inicio="minFechaInicio"
                :max-fecha-inicio="maxFechaInicio"
                :min-fecha-fin="minFechaFin"
                :max-fecha-fin="maxFechaFin"
                :rango-sesion="rangoSesion"
                :aviso-rango-fechas="avisoRangoFechas"
                :puede-editar-cierre-venta="puedeEditarCierreVenta"
                :mostrar-fecha-provisional="mostrarFechaProvisional"
                @update:fecha-inicio="form.fecha_inicio = $event"
                @update:fecha-fin="form.fecha_fin = $event"
                @update:fecha-cierre-venta="form.fecha_cierre_venta = $event"
                @update:fecha-provisional="form.fecha_provisional = $event"
                @update:text="form.text = $event"
                @update:apertura="form.apertura_puertas = $event"
            />
        </ValidationObserver>

        <!-- El botón de acción vive en el footer del modal, alineado a la
             derecha como en el resto de modales modernos del admin. Al no
             estar dentro del <form>, dispara submit() por click. -->
        <template #footer>
            <div class="tw:flex tw:justify-end tw:gap-2">
                <Button
                    id="editar-sesion"
                    data-cy="editar-sesion"
                    :loading="loading"
                    :disabled="loading"
                    @click="submit"
                >
                    Editar
                </Button>
            </div>
        </template>
    </ModalBase>
</template>

<script setup>
    import { ref, computed } from 'vue';
    import ModalBase from '@/modules/admin/ui/ModalBase.vue';
    import Button from '@/modules/admin/ui/Button.vue';
    import FormSesion from '@/components/backend/eventos/sesiones/FormSesion.vue';
    import { useSesionForm } from '@/composables/admin/eventos/useSesionForm';
    import { formatSesionFecha } from '@/utils/dateUtils';

    const props = defineProps({
        sesion: {
            type: Object,
            required: true,
        },
        evento: {
            type: Object,
            required: true,
        },
    });

    const emit = defineEmits(['close']);

    const observer = ref(null);

    // La sesión viene del listado v2: `start_at` es un instante ISO 8601.
    const fechaFormateada = computed(() => formatSesionFecha(props.sesion.start_at));

    const {
        form,
        loading,
        minFechaInicio,
        maxFechaInicio,
        minFechaFin,
        maxFechaFin,
        rangoSesion,
        avisoRangoFechas,
        puedeEditarCierreVenta,
        mostrarFechaProvisional,
        submitSesion,
    } = useSesionForm({ sesion: props.sesion, evento: props.evento, mode: 'editar' });

    const close = editado => {
        emit('close', 'editar-sesion-' + props.sesion.id, editado);
    };

    const submit = async() => {
        const isValid = await observer.value.validate();
        if (!isValid) return;

        const ok = await submitSesion();
        if (ok) close(true);
    };
</script>
